(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabbed-product-lists"] && !Shopify.designMode) return;
  try {
    
  if (typeof TabbedProductLists !== 'function') {
    class TabbedProductLists extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tabbed-product-tab]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        for (const tab of this.tabs) {
          tab.addEventListener('click', this.#handleTabClick);
          tab.addEventListener('keydown', this.#handleTabKeydown);
        }

        const activeTab = this.querySelector('.tabbed-product-lists__tab--active');

        if (activeTab instanceof HTMLButtonElement) {
          this.#centerTab(activeTab, 'auto');
        }
      }

      disconnectedCallback() {
        if (!this.tabs) return;

        for (const tab of this.tabs) {
          tab.removeEventListener('click', this.#handleTabClick);
          tab.removeEventListener('keydown', this.#handleTabKeydown);
        }
      }

      #handleTabClick = (event) => {
        const tab = event.currentTarget;

        if (!(tab instanceof HTMLButtonElement)) return;

        this.#selectTab(tab, true);
      };

      #handleTabKeydown = (event) => {
        const currentIndex = this.tabs.indexOf(event.currentTarget);

        if (currentIndex === -1) return;

        const nextIndex = this.#getNextIndex(event.key, currentIndex);

        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.#selectTab(this.tabs[nextIndex], true);
      };

      #getNextIndex(key, currentIndex) {
        const lastIndex = this.tabs.length - 1;

        if (key === 'ArrowRight') {
          return currentIndex === lastIndex ? 0 : currentIndex + 1;
        }

        if (key === 'ArrowLeft') {
          return currentIndex === 0 ? lastIndex : currentIndex - 1;
        }

        if (key === 'Home') {
          return 0;
        }

        if (key === 'End') {
          return lastIndex;
        }

        return currentIndex;
      }

      #selectTab(selectedTab, moveFocus) {
        for (const tab of this.tabs) {
          const isSelected = tab === selectedTab;

          tab.classList.toggle('tabbed-product-lists__tab--active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
        }

        for (const panel of this.panels) {
          const isSelectedPanel = panel.id === selectedTab.getAttribute('aria-controls');

          panel.hidden = !isSelectedPanel;

          if (isSelectedPanel) {
            this.#resetSlider(panel);
          }
        }

        if (moveFocus) {
          selectedTab.focus();
        }

        this.#centerTab(selectedTab, 'smooth');
      }

      #resetSlider(panel) {
        requestAnimationFrame(() => {
          const slider = panel.querySelector('css-slider');

          if (!slider || typeof slider.resetSlider !== 'function') return;

          slider.resetSlider(true);
        });
      }

      #centerTab(tab, behavior) {
        requestAnimationFrame(() => {
          tab.scrollIntoView({
            behavior,
            block: 'nearest',
            inline: 'center'
          });
        });
      }
    }

    if (typeof customElements.get('tabbed-product-lists') === 'undefined') {
      customElements.define('tabbed-product-lists', TabbedProductLists);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
